<template>
  <form id="reset-password" @submit.prevent="resetPassword">
    <h1 class="title">Redefinir senha</h1>
    <p class="subtitle">
    </p>

    <div class="alert -danger" v-if="errors.unrecognized">
      <p class="title">Ops!</p>

      <p>Ocorreu um erro ao redefinir sua senha, tente novamente.</p>
    </div>

    <div class="alert -danger" v-if="errors.form.token.length > 0">
      <p class="title">Ops!</p>

      <p>Esse link de redefinição de senha é inválido.</p>
    </div>

    <div class="alert -success" v-if="finished">
      <p>Sua senha foi redefinida, <router-link to="/login">faça login</router-link>.</p>
    </div>

    <div class="form-group" :class="{'-has-error': errors.form.password.length > 0}">
      <label for="password" class="label">Senha</label>
      <input
        class="form-control"
        id="password"
        type="password"
        placeholder="******************"
        autocomplete
        v-model="form.password"
        required
      >
      <p class="description" v-if="errors.form.password.length > 0">{{ errors.form.password[0] }}</p>
    </div>

    <div class="form-group">
      <label for="password_confirmation" class="label">Confirmar senha</label>
      <input
        class="form-control"
        id="password_confirmation"
        type="password"
        placeholder="******************"
        autocomplete
        v-model="form.password_confirmation"
        required
      >
    </div>

    <div class="actions">
      <button class="btn btn-primary -full-width" type="submit">
        Redefinir
      </button>
    </div>

    <div class="callLogin">
      <p>Sabe sua senha? <router-link to="/login">Faça login</router-link>.</p>
    </div>

    <loader
      background="#FFF"
      v-if="loading"/>
  </form>
</template>

<script>
import { mask } from 'vue-the-mask';
import Loader from '@/support/components/Loader.vue';
import checkErrorIsUnrecognizedResponse from '@/support/helpers/checkErrorIsUnrecognizedResponse';

export default {
  name: 'ResetPassword',

  data() {
    return {
      form: {
        password: '',
        password_confirmation: '',
      },

      finished: false,
      loading: false,

      errors: {
        unrecognized: false,
        form: {
          token: [],
          password: [],
          password_confirmation: [],
        },
      },
    };
  },

  methods: {
    /**
     * Reset the password.
     *
     * @returns {Promise<void>}
     */
    async resetPassword() {
      try {
        this.loading = true;
        this.resetErrors();

        await this.$store.dispatch('auth/resetPassword', {
          ...this.form,
          token: this.$route.params.token,
          email: this.$route.query.email,
        });

        this.resetFields();
        document.getElementById('reset-password').reset();
        this.finished = true;
      } catch (err) {
        if (checkErrorIsUnrecognizedResponse(err, [422])) {
          this.errors.unrecognized = true;

          return;
        }

        const { data, status } = err.response;

        if (status === 422) {
          this.errors.form.token = data.errors.token || data.errors.email || [];
          this.errors.form.password = data.errors.password || [];
        }
      } finally {
        this.loading = false;
      }
    },

    /**
     * Reset the errors page.
     */
    resetErrors() {
      this.errors.form.password = [];
      this.errors.form.password_confirmation = [];
      this.errors.unrecognized = false;
    },
    resetFields() {
      this.form.password = '';
      this.form.password_confirmation = '';
    },
  },

  computed: {
  },

  directives: {
    mask,
  },

  components: {
    Loader,
  },
};
</script>

<style lang="scss" scoped>
  #reset-password {
    @apply relative;

    > .title {
      @apply text-xl;
      @apply font-bold;
      @apply text-secondary-700;
      letter-spacing: -0.01em;
      margin-bottom: 8px;
    }

    > .subtitle {
      @apply text-sm;
      @apply mb-5;
      @apply text-gray-800;
    }

    > .form-group {
      @apply mb-5;
    }

    > .actions {
      @apply mb-5;
    }

    > .callLogin {
      @apply text-sm;
      @apply mb-5;
      @apply text-gray-800;
    }
  }
</style>
